module.exports = __webpack_public_path__ + "static/media/markescermoni_pensionarer.6ea09980.jpg";